import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { UserService } from "@app-service/user.service";

@Component({
    selector: "app-meal-card-info",
    templateUrl: "./meal-card-info.component.html",
    styleUrls: ["./meal-card-info.component.scss"],
    standalone: false
})
export class MealCardInfoComponent implements OnInit {
  constructor(private router: Router, public userService: UserService, private dashboardCardsService: DashboardCardsService) {}

  ngOnInit(): void {}

  onSettingUp(): void {
    this.dashboardCardsService.changeActiveDisplayTab('cards');
    this.router.navigate(["cards/dashboard-cards"]);
  }
}
